import axios from "axios";
import CommonUtil from "../../Util/CommonUtils";
import Toast from "../../components/ToastContainer/CustomToast";
import store from "../../config/configureStore";
import { startLoader, stopLoader } from "../../slices/Loader/LoaderSlice";
import { REACT_LOGIN } from "../../actions/EndPoints";

const formatDayAndMonth = (numValue) => {
  if (numValue <= 0) {
    return "-" + (numValue + 12);
  }
  if (numValue < 10) {
    return "-0" + numValue;
  } else {
    return "-" + numValue;
  }
};

var today = new Date();
var endDate =
  today.getFullYear() +
  formatDayAndMonth(today.getMonth() + 1) +
  formatDayAndMonth(today.getDate()) +
  "T23:59:59";
var startDate =
  today.getFullYear() +
  formatDayAndMonth(today.getMonth() + 1) +
  formatDayAndMonth(today.getDate()) +
  "T00:00";

export const exportCheckoutVistorsLogs = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryCheckOut = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/checked_out/export" + buildQueryCheckOut(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "DailyReport" + "." + `${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }

      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryCheckOut = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/checked_out/export" + buildQueryCheckOut(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "CheckedOutVisitors log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportCheckInVistorsLogs = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryCheckIn = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/checked_in/export" + buildQueryCheckIn(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "DailyReport_checked_in" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }

      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryCheckIn = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/checked_in/export" + buildQueryCheckIn(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "CheckInVisitors log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportCancelledVistorsLogs = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryCancelled = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/cancelled/export" + buildQueryCancelled(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "DailyReport_cancelled" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }

      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryCancelled = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/cancelled/export" + buildQueryCancelled(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "CancelledVisitors log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportMissedVistorsLogs = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryMissed = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/missed/export" + buildQueryMissed(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "DailyReport_missed" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }

      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryMissed = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/missed/export" + buildQueryMissed(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "MissedVisitors log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportRejectedVistorsLogs = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryReject = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/rejected/export" + buildQueryReject(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "DailyReport_rejected" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }

      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryReject = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/rejected/export" + buildQueryReject(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },

  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "RejectedVisitors log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportAllVistorsLogs = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryAll = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/allVisitors/export" + buildQueryAll(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "DailyReport_allVisitors" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }

      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryAll = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/allVisitors/export" + buildQueryAll(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "AllVisitors log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportBlacklistVisitors = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  store.dispatch(startLoader());
  const buildBlacklistVisitors = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/blacklist/export" + buildBlacklistVisitors(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "BlockListVisitors" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
};

export const exportInvitationVisitors = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryInvitation = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url: "/web/invitation/export" + buildQueryInvitation(filter) + searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Invitation" + "." + `${typeFile}`); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryInvitation = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url: "/web/invitation/export" + buildQueryInvitation(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   params: {
  //     visitMode: "INVITATION",
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "Invitation log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportWalkInRegistrationVisitors = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryWalkInRegistration = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url:
      "/web/walkInRegistration/export" +
      buildQueryWalkInRegistration(filter) +
      searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Walk-In Registration" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQueryWalkInRegistration = (filter) => {
  //   let query =
  //     "?pageNumber=" + filter.page + "&pageSize=" + filter.rowsPerPage;
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url:
  //     "/web/walkInRegistration/export" + buildQueryWalkInRegistration(filter),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "WalkIn Registartion log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportSelfRegistrationVisitors = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
  rowsPerPage,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQuerySelfRegistration = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    // if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
    //   query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
    // }
    // if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
    //   query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
    // }
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url:
      "/web/selfRegistration/export" +
      buildQuerySelfRegistration(filter) +
      searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Self Registration" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
  // const buildQuerySelfRegistration = (filter, page, rowsPerPage) => {
  //   let query = "?isPagable=true&pageNumber=" + page + "&pageSize=" + "1000";
  //   if (!CommonUtil.isEmptyString(filter.scheduledStartDate)) {
  //     query = query + "&scheduledStartDate=" + filter.scheduledStartDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.scheduledEndDate)) {
  //     query = query + "&scheduledEndDate=" + filter.scheduledEndDate;
  //   }
  //   if (!CommonUtil.isEmptyString(filter.status)) {
  //     query = query + "&status=" + filter.status;
  //   }
  //   return query;
  // };

  // axios({
  //   url:
  //     "/web/selfRegistration/export" +
  //     buildQuerySelfRegistration(filter, page, rowsPerPage),
  //   method: "get",
  //   headers: {
  //     "Content-type": "application/json",
  //     Authorization: localStorageHelper.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  //     companyId: localStorageHelper.getItem("companyId"),
  //     "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   },
  //   params: {
  //     visitMode: "SELF_REGISTARTION",
  //   },
  //   responseType: "blob",
  // }).then((response) => {
  //   try {
  //     if (response.status !== 204) {
  //       const blob = new Blob([response.data], {
  //         type:
  //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  //       });
  //       const aEle = document.createElement("a");
  //       const href = window.URL.createObjectURL(blob);
  //       aEle.href = href;
  //       aEle.download = "Self Registartion log.xlsx";
  //       document.body.appendChild(aEle);
  //       aEle.click();
  //       document.body.removeChild(aEle);
  //       window.URL.revokeObjectURL(href);
  //       onSuccess();
  //     } else {
  //       Toast("No Records Found", "error");
  //     }
  //   } catch {
  //     onFailure();
  //   }
  // });
};

export const exportPreRegistrationVisitors = (
  onSuccess,
  onFailure,
  filter,
  searchParam,
) => async (dispatch) => {
  store.dispatch(startLoader());
  var typeFile = "";
  if (filter.fileType === "0") {
    typeFile = "PDF";
  } else if (filter.fileType === "1") {
    typeFile = "XLSX";
  } else if (filter.fileType === "2") {
    typeFile = "CSV";
  } else {
    alert("Not selected");
  }
  const buildQueryWalkInRegistration = (filter) => {
    let query =
      "?fileType=" +
      typeFile +
      "&fromPage=" +
      filter?.from +
      "&toPage=" +
      filter?.to;
    if (!CommonUtil.isEmptyString(filter.status)) {
      query = query + "&status=" + filter.status;
    }
    return query;
  };

  axios({
    url:
      "/web/preRegistration/export" +
      buildQueryWalkInRegistration(filter) +
      searchParam,
    method: "get",
    headers: {
      "Content-type": "application/json",
      Authorization: localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
      companyId: localStorage.getItem("companyId"),
      "time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    responseType: "blob",
  })
    .then((response) => {
      try {
        if (response.status !== 204) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Pre Registration" + "." + `${typeFile}`,
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          onSuccess();
        } else {
          Toast("No Records Found", "error");
        }
      } catch {
        onFailure();
      }
      store.dispatch(stopLoader());
    })
    .catch((error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== REACT_LOGIN
      ) {
        window.location = REACT_LOGIN; // Redirect if unauthorized
      } else {
        Toast("Something went wrong.", "error");
      }
      onFailure();
    })
    .finally(() => {
      store.dispatch(stopLoader());
    });
};
